<!-- ************************************************************************************************* -->
<waitLoading *ngIf="!isLoaded()"></waitLoading>
<!-- ************************************************************************************************* -->
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
  <div *ngIf="
    criteriaDefList && criteriaDefList.length > 0;
      else nocustomFields
    ">
    <p-panel>
      <p-header>
        <span class="label label-default float-right" style="font-size: small;font-weight: 500;">{{ 'Tasks.showing' |
          translate }} {{ criteriaDefList ? criteriaDefList.length : '0' }} criterios </span>
      </p-header>
      <p-table [value]="criteriaDefList" sortField="name" sortOrder="1" [scrollable]="false" [resizableColumns]="true"
        class="footer-over-pagination" [paginator]="false">
        <ng-template pTemplate="header">
          <tr>
            <th [pSortableColumn]="'name'"> Nombre </th>
            <th [pSortableColumn]="'type'" class="TEXT"> Tipo </th>
            <th class="TEXT"> Contexto </th>
            <th class="action-column"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-criteriaDef>
          <tr>
            <td field="name"> {{criteriaDef.name}} <div>
                <span><small>{{criteriaDef.description}}</small></span>
              </div>
            </td>
            <td field="type" class="TEXT"> {{criteriaDef.type}} </td>
            <td field="name" class="TEXT"> {{criteriaDef.type}} </td>
            <td>
              <button class="btn btn-xs btn-default" aria-expanded="false" (click)="editCriteriaDef(criteriaDef)"
                type="button">
                <i class="fas fa-download" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-panel>
  </div>
</div>
<ng-template #nocustomFields>
  <div class="alert alert-danger m-b-xs text-ellipsis col-12 ng-star-inserted" role="alert">
    <span>
      <i aria-hidden="true" class="fas fa-1-5x fa-exclamation-circle m-r-md"></i> {{
      'ControlPanel.criteriaDefList.noCriteriaDefAvailable' | translate }}</span>
  </div>
</ng-template>